export default __webpack_public_path__ + "static/media/broken.f58236a8.svg";